<template>
	<div v-show="estado !== 'standby'" class="chat-camera">

		<span class="videos">

			<video class="peer-video" ref="peerVideo"></video>

			<div>

				<video class="my-video" ref="myVideo"></video>

			</div>

		</span>

		<div v-if="estado === 'conectando'" class="estado">{{ msg }}</div>

		<div class="botones">

			<el-button
				circle
				type="danger"
				icon="el-icon-phone"
				title="Colgar"
				@click="cerrarConexion"
			/>

			<el-button
				circle
				:icon="silenciado ? 'el-icon-microphone' : 'el-icon-turn-off-microphone'"
				title="Silenciar microfono"
				@click="silenciar"
			/>

		</div>

	</div>
</template>

<script>
	import Peer from 'simple-peer'
	import getUserMedia from 'getusermedia'

	export default {
		name: 'ChatCamara',
		props: {
			ws: {
				required: true
			},
			partner: {
				required: true
			}
		},
		data () {
			return {
				msg: 'Solicitando conexión',
				estado: 'standby',
				llamadaEntrante: false,
				peer: null,
				stream: null,
				silenciado: false
			}
		},
		watch: {

			partner () {

				if (this.llamadaEntrante) return

				this.cerrarConexion()

			}

		},
		created () {

			Notification.requestPermission()

			this.ws.onMsg('iniciarWebcam', this.onIniciarWebcam)

			this.ws.onMsg('aceptarWebcam', this.onAceptarWebcam)

			this.ws.onMsg('usuarioDesconectado', this.onUsuarioDesconectado)

			this.ws.onMsg('rechazarLlamada', this.onRechazarLlamada)

		},
		beforeDestroy () {

			this.ws.delMsg('iniciarWebcam', this.onIniciarWebcam)

			this.ws.delMsg('aceptarWebcam', this.onAceptarWebcam)

			this.ws.delMsg('usuarioDesconectado', this.onUsuarioDesconectado)

			this.ws.delMsg('rechazarLlamada', this.onRechazarLlamada)

		},
		methods: {

			silenciar () {

				this.silenciado = !this.silenciado

				this.stream.getAudioTracks().forEach(a => a.enabled = this.silenciado)

			},

			onUsuarioDesconectado (user) {

				if (!user || !this.partner.id) return

				if (user.id === this.partner.id) this.$emit('partner', {})

			},

			click (partner) {

				this.$emit('partner', partner)

				if (this.estado === 'standby') {

					this.iniciarConexion(true)

					return

				}

				this.cerrarConexion()

			},

			cerrarConexion () {

				this.estado = 'standby'

				if (this.peer) {

					this.peer.destroy()

					this.peer = null

				}

				if (this.stream) this.stream.getTracks().forEach(t => t.stop())

				this.$refs.myVideo.srcObject = null

				this.$refs.peerVideo.srcObject = null

			},

			async iniciarConexion (inst = false) {

				const devices = (await navigator.mediaDevices.enumerateDevices()).map(d => d.kind)

				const options = {}

				if (devices.includes('videoinput')) options.video = true

				if (devices.includes('audioinput')) options.audio = true

				return new Promise((resolve) => {

					getUserMedia(options, (err, stream) => {

						const options = {
							initiator: inst,
							trickle: false
						}

						if (stream) {

							options.stream = stream

							this.$refs.myVideo.srcObject = stream

							this.$refs.myVideo.volume = 0

							this.$refs.myVideo.play()

							this.stream = stream

						}

						const peer = new Peer(options)

						peer.on('signal', async data => {

							if (this.estado === 'conectado') return

							if (data.type === 'renegotiate' || data.type === 'answer') {

								this.msg = 'Estableciendo conexión'

								this.ws.sendMsg('aceptarWebcam', {
									data: data,
									partner: this.partner.id
								})

							}

							if (data.type === 'offer') {

								this.msg = 'Esperando respuesta'

								this.ws.sendMsg('iniciarWebcam', {
									data: data,
									partner: this.partner.id
								})

							}

							this.estado = 'conectando'

						})

						peer.on('connect', () => { this.estado = 'conectado' })

						peer.on('stream', stream => {

							this.$refs.peerVideo.srcObject = stream

							this.$refs.peerVideo.play()

						})

						peer.on('close', () => { this.cerrarConexion() })

						peer.on('error', () => { this.cerrarConexion() })

						this.peer = peer

						resolve()

					})

				})

			},

			onRechazarLlamada () { this.cerrarConexion() },

			onIniciarWebcam ({ data, partner }) {

				this.$emit('dialog', {
					title: 'Llamada entrante',
					msg: `Recibiendo llamada de ${partner.name}`,
					acceptText: 'Aceptar',
					cancelText: 'Rechazar',
					cancel: () => { this.ws.sendMsg('rechazarLlamada', partner.id) },
					accept: async () => {

						this.llamadaEntrante = true

						this.$emit('partner', partner)

						await this.cerrarConexion()

						await this.iniciarConexion()

						this.peer.signal(data)

						this.llamadaEntrante = false

					}
				})

			},

			onAceptarWebcam ({ data }) {

				this.peer.signal(data)

			}

		}
	}
</script>
